export default "__VITE_ASSET__BqWNX0b8__"